import { DEFAULT_COLUMN_STYLE } from '~/components/MultiGrid/constants';
import { IBaseFieldData, IColumnStyle } from '~/components/MultiGrid/types';

export const EMAIL_FIELDS_ORDER = [
  'recipient_name',
  'recipient_email',
  'subject',
  'template_id',
  'status',
  'sent_at',
];

export const EMAIL_ALL_FIELDS: Record<IBaseFieldData['value'], IBaseFieldData & IColumnStyle> =
  Object.freeze({
    recipient_name: {
      label: 'Recipient Name',
      value: 'recipient_name',
      ...DEFAULT_COLUMN_STYLE,
      width: 180,
      isStatic: true,
    },
    recipient_email: {
      label: 'Email',
      value: 'recipient_email',
      ...DEFAULT_COLUMN_STYLE,
      width: 250,
    },
    subject: {
      label: 'Subject',
      value: 'subject',
      ...DEFAULT_COLUMN_STYLE,
      width: 300,
    },
    template_id: {
      label: 'Template',
      value: 'template_id',
      ...DEFAULT_COLUMN_STYLE,
      width: 200,
    },
    status: {
      label: 'Status',
      value: 'status',
      ...DEFAULT_COLUMN_STYLE,
      width: 120,
    },
    sent_at: {
      label: 'Sent At',
      value: 'sent_at',
      ...DEFAULT_COLUMN_STYLE,
      isCellFullWidth: true,
      width: 180,
    },
  });

export interface IListEmail {
  id: number;
  email_uuid: string;
  recipient_email: string;
  recipient_name: string;
  subject: string;
  template_id: string;
  status: string;
  sent_at: string;
  opened_at: string | null;
  failed_at: string | null;
  invoice: string | null;
  estimate: string | null;
  created_on: string;
}

export const TEMPLATE_MAPPER: Record<string, string> = {
  invoice_email: 'Shared Invoice',
};
